import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Log pages
export const LogListPage = lazy(
  () =>
    retry(() => import('@pages/settings/logs/list')) as Promise<
      typeof import('@pages/settings/logs/list')
    >
);

export const LogDetailPage = lazy(
  () =>
    retry(() => import('@pages/settings/logs/detail')) as Promise<
      typeof import('@pages/settings/logs/detail')
    >
);

// Feature Flag pages
export const FeatureFlagListPage = lazy(
  () =>
    retry(() => import('@pages/settings/feature-flags/list')) as Promise<
      typeof import('@pages/settings/feature-flags/list')
    >
);

export const FeatureFlagCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/feature-flags/create')) as Promise<
      typeof import('@pages/settings/feature-flags/create')
    >
);

export const FeatureFlagEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/feature-flags/edit')) as Promise<
      typeof import('@pages/settings/feature-flags/edit')
    >
);
